// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wo-0";
export var confirmationIcon = "_wo-1";